import { render } from "./InterestLists.vue?vue&type=template&id=5e8aeb52"
import script from "./InterestLists.vue?vue&type=script&lang=js"
export * from "./InterestLists.vue?vue&type=script&lang=js"

import "./InterestLists.vue?vue&type=style&index=0&id=5e8aeb52&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__